export default __webpack_public_path__ + "static/media/38_4_0.2627d052.png";